// extracted by mini-css-extract-plugin
export default {"p_tye":"_096b71817f","slcted":"_8ab53bff33","slc_color":"_3b73ffaf0a","item_p":"ceeb5146bf","r0":"_82979802bb"};